import { MerchantType, Package } from "@/enums/enums";
import { MerchantInFoModel } from "@/model/merchant/MerchantInFoModel";
import {
  MerchantPackageRightApplicationModel,
  MerchantPackageRightModel,
  MerchantPackageRightPeakAccountApplicationAccountingPolicySettingModel,
  MerchantPackageRightPeakAccountApplicationAccountsModel,
  MerchantPackageRightPeakAccountApplicationDocumentSettingModel,
  MerchantPackageRightPeakAccountApplicationExpenseModel,
  MerchantPackageRightPeakAccountApplicationFinanceModel,
  MerchantPackageRightPeakAccountApplicationModel,
  MerchantPackageRightPeakAccountApplicationRevenueModel,
  MerchantPackageRightPeakAccountApplicationSettingModel,
  MerchantPackageRightPeakAccountApplicationUserSettingModel,
  MerchantPackageRightPeakAssetApplicationModel,
  MerchantPackageRightPeakTaxApplicationModel,
  SelectedMerchantModel,
  UserRoleInfoModel,
} from "@/model/merchant/selectedMerchantModel";

function GetMerchantPackageRightApplication(applicationRaw: any): MerchantPackageRightApplicationModel {
  return {
    peakAccount: applicationRaw.peakAccount,
    oldPeakAccount: applicationRaw.oldPeakAccount,
    peakPayroll: applicationRaw.peakPayroll,
    peakAsset: applicationRaw.peakAsset,
    peakBoard: applicationRaw.peakBoard,
    peakTax: applicationRaw.peakTax,
    peakLineConnect: applicationRaw.peakLineConnect,
    peakMobile: applicationRaw.peakMobile,
    peakDocument: applicationRaw.peakDocument,
  };
}
function GetMerchantPackageRightPeakAccountApplicationRevenue(
  revenueRaw: any
): MerchantPackageRightPeakAccountApplicationRevenueModel {
  return {
    quotation: revenueRaw.quotation,
    invoice: revenueRaw.invoice,
    invoiceAsset: revenueRaw.invoiceAsset,
    receipt: revenueRaw.receipt,
    receiptAsset: revenueRaw.receiptAsset,
    taxInvoice: revenueRaw.taxInvoice,
    creditNote: revenueRaw.creditNote,
    billingNote: revenueRaw.billingNote,
    debitNote: revenueRaw.debitNote,
    recurringInvoice: revenueRaw.recurringInvoice,
    recurringReceipt: revenueRaw.recurringReceipt,
  };
}
function GetMerchantPackageRightPeakAccountApplicationExpense(
  expenseRaw: any
): MerchantPackageRightPeakAccountApplicationExpenseModel {
  return {
    purchaseOrder: expenseRaw.purchaseOrder,
    purchaseOrderAsset: expenseRaw.purchaseOrderAsset,
    expense: expenseRaw.expense,
    purchaseAsset: expenseRaw.purchaseAsset,
    purchaseTaxInvoice: expenseRaw.purchaseTaxInvoice,
    receivedCreditNote: expenseRaw.receivedCreditNote,
    receivedDebitNote: expenseRaw.receivedDebitNote,
    combinePaymentNote: expenseRaw.combinePaymentNote,
    recurringExpense: expenseRaw.recurringExpense,
  };
}
function GetMerchantPackageRightPeakAccountApplicationFinance(
  financeRaw: any
): MerchantPackageRightPeakAccountApplicationFinanceModel {
  return {
    addFinance: financeRaw.addFinance,
    reconcile: financeRaw.reconcile,
    statement: financeRaw.statement,
  };
}
function GetMerchantPackageRightPeakAccountApplicationAccounts(
  accountRaw: any
): MerchantPackageRightPeakAccountApplicationAccountsModel {
  return {
    addAccount: accountRaw.addAccount,
    actionJournal: accountRaw.actionJournal,
  };
}
function GetMerchantPackageRightPeakAccountApplicationDocumentSetting(
  documentRaw: any
): MerchantPackageRightPeakAccountApplicationDocumentSettingModel {
  return {
    cassification: documentRaw.cassification,
    redirectLinkReport: documentRaw.redirectLinkReport,
    taxInvoice: documentRaw.taxInvoice,
    journal: documentRaw.journal,
  };
}
function GetMerchantPackageRightPeakAccountApplicationUserSetting(
  userRaw: any
): MerchantPackageRightPeakAccountApplicationUserSettingModel {
  return {
    userRoleContact: userRaw.userRoleContact,
  };
}
function GetMerchantPackageRightPeakAccountApplicationAccountingPolicySetting(
  accountingPolicyRaw: any
): MerchantPackageRightPeakAccountApplicationAccountingPolicySettingModel {
  return {
    summaryReport: accountingPolicyRaw.summaryReport,
    creditLimit: accountingPolicyRaw.creditLimit,
    purchaseOrderStatusUpdate: accountingPolicyRaw.purchaseOrderStatusUpdate,
  };
}
function GetMerchantPackageRightPeakAccountApplicationSetting(
  settingRaw: any
): MerchantPackageRightPeakAccountApplicationSettingModel {
  return {
    user: GetMerchantPackageRightPeakAccountApplicationUserSetting(settingRaw.user),
    document: GetMerchantPackageRightPeakAccountApplicationDocumentSetting(settingRaw.document),
    accountingPolicy: GetMerchantPackageRightPeakAccountApplicationAccountingPolicySetting(settingRaw.accountingPolicy),
    applicationConnect: settingRaw.applicationConnect,
  };
}
function GetMerchantPackageRightPeakAccountApplication(
  accountRaw: any
): MerchantPackageRightPeakAccountApplicationModel {
  return {
    totalDocumentPerMonth: accountRaw.totalDocumentPerMonth,
    export: accountRaw.export,
    importProduct: accountRaw.importProduct,
    importContact: accountRaw.importContact,
    importTransaction: accountRaw.importTransaction,
    partailPayment: accountRaw.partailPayment,
    revenue: GetMerchantPackageRightPeakAccountApplicationRevenue(accountRaw.revenue),
    expense: GetMerchantPackageRightPeakAccountApplicationExpense(accountRaw.expense),
    finance: GetMerchantPackageRightPeakAccountApplicationFinance(accountRaw.finance),
    account: GetMerchantPackageRightPeakAccountApplicationAccounts(accountRaw.account),
    fileVault: accountRaw.fileVault,
    setting: GetMerchantPackageRightPeakAccountApplicationSetting(accountRaw.setting),
  };
}
function GetMerchantPackageRightPeakTaxApplication(taxRaw: any): MerchantPackageRightPeakTaxApplicationModel {
  return { fetchDataFromPeakAccount: taxRaw.fetchDataFromPeakAccount };
}
function GetMerchantPackageRightPeakAssetApplication(assetRaw: any): MerchantPackageRightPeakAssetApplicationModel {
  return { totalAsset: assetRaw.totalAsset };
}
function GetMerchantPackageRight(merchantPackageRightRaw: any): MerchantPackageRightModel {
  return {
    totalUserId: merchantPackageRightRaw.totalUserId,
    application: GetMerchantPackageRightApplication(merchantPackageRightRaw.application),
    account: GetMerchantPackageRightPeakAccountApplication(merchantPackageRightRaw.account),
    tax: GetMerchantPackageRightPeakTaxApplication(merchantPackageRightRaw.tax),
    asset: GetMerchantPackageRightPeakAssetApplication(merchantPackageRightRaw.asset),
  };
}
function GetRole(userRoleRaw: any): UserRoleInfoModel {
  return {
    authorityRole: userRoleRaw.authorityRole,
    role: userRoleRaw.role,
    manageUser: userRoleRaw.manageUser,
    manageFinance: userRoleRaw.manageFinance,
    isSuperUser: userRoleRaw.isSuperUser,
    isUsePayroll: userRoleRaw.isUsePayroll,
    isUsePeakBoard: userRoleRaw.isUsePeakBoard,
    manageProduct: userRoleRaw.manageProduct,
    isSeeSelfDocuments: userRoleRaw.isSeeSelfDocuments,
    manageFinanceAndJournals: userRoleRaw.manageFinanceAndJournals,
    manageAsset: userRoleRaw.manageAsset,
    manageContact: userRoleRaw.manageContact,
    isViewReport: userRoleRaw.isViewReport,
  };
}
export function GetSelectedMerchant(merchantRaw: any): SelectedMerchantModel {
  return {
    merchantId: merchantRaw.merchantId,
    merchantName: merchantRaw.merchantName,
    merchantNameEng: merchantRaw.merchantNameEng,
    merchantNameTh: merchantRaw.merchantNameTh,
    merchantBranchCode: merchantRaw.merchantBranchCode,
    active: false,
    merchantTaxId: merchantRaw.merchantTaxId,
    code: merchantRaw.code,
    createDateTime: merchantRaw.createDateTime,
    isAccountingFirm: merchantRaw.isAccountingFirm,
    merchantType: merchantRaw.merchantType,
    taxStatus: merchantRaw.taxStatus,
    logoUrl: merchantRaw.logoUrl,
    stampUrl: merchantRaw.stampUrl,
    isSample: merchantRaw.isSample,
    isVat: merchantRaw.isVat,
    isActivePayroll: merchantRaw.isActivePayroll,
    isLockPeriod: merchantRaw.isLockPeriod,
    lockPeriodEndDate: merchantRaw.lockPeriodEndDate,
    joinMerchantDateTime: merchantRaw.joinMerchantDateTime,
    package: merchantRaw.package,
    mainPackage: merchantRaw.mainPackage,
    expireDateTime: merchantRaw.expireDateTime,
    packageName: merchantRaw.packageName,
    merchantPackageRight: GetMerchantPackageRight(merchantRaw.merchantPackageRight),
  };
}

const PackageNameMap: Record<number, string> = {
  [Package.Trial]: "TRIAL",
  [Package.Free]: "FREE",
  [Package.EDocument]: "e-Document",
  [Package.Basic]: "BASIC",
  [Package.Pro]: "PRO",
  [Package.ProPlus]: "PRO Plus",
  [Package.AFPFree]: "AFP FREE",
  [Package.AFPLedger]: "LEDGER",
  [Package.AFPAccountant]: "ACCOUNTANT",
  [Package.Premium]: "PREMIUM",
};

// Trial shows the package being trialled (mainPackage), same as peakexperience badge
export function GetBadgePackageClass(merchant: SelectedMerchantModel): number {
  return merchant.package === Package.Trial ? merchant.mainPackage : merchant.package;
}

export function GetBadgePackageName(merchant: SelectedMerchantModel): string {
  return merchant.package === Package.Trial ? `${PackageNameMap[merchant.mainPackage]} Trial` : merchant.packageName;
}

export function IsOrdinaryPerson(contactType: MerchantType) {
  const isOrdinaryPerson =
    contactType === MerchantType.OrdinaryPerson ||
    contactType === MerchantType.Shop ||
    contactType === MerchantType.OrdinaryPartnership ||
    contactType === MerchantType.BodyOfPersons;
  return isOrdinaryPerson;
}

export function ConvertToMerchantList(merchantListRaw: any): Array<MerchantInFoModel> {
  const merchantList: Array<MerchantInFoModel> = [];
  if (merchantListRaw && merchantListRaw.length > 0) {
    for (const merchantRaw of merchantListRaw) {
      merchantList.push({
        merchantId: merchantRaw.merchantId,
        merchantName: merchantRaw.merchantName,
        merchantNameEng: merchantRaw.merchantNameEng,
        merchantNameTh: merchantRaw.merchantNameTh,
        merchantBranchCode: merchantRaw.merchantBranchCode,
        isSample: merchantRaw.isSample,
        merchantTaxId: merchantRaw.merchantTaxId,
        active: false,
      });
    }
  }
  return merchantList;
}

export function CompareMerchantNameTh(a: MerchantInFoModel, b: MerchantInFoModel) {
  if (a.merchantNameTh < b.merchantNameTh) {
    return -1;
  } else if (a.merchantNameTh > b.merchantNameTh) {
    return 1;
  } else {
    return 0;
  }
}

export function CompareMerchantNameEn(a: MerchantInFoModel, b: MerchantInFoModel) {
  if (a.merchantNameEng < b.merchantNameEng) {
    return -1;
  } else if (a.merchantNameEng > b.merchantNameEng) {
    return 1;
  } else {
    return 0;
  }
}
